import React from "react";
import "./AboutUsMap.css";

const AboutUsMap = () => {
  return (
    <div className="about-us-container">
      <div className="about-us-map">
        <div className="map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3902.6767754909934!2d120.19983057581639!3d11.996852888236035!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x33ba1f8071e3e8c5%3A0x675cf43683ba19f!2sTwin%20Travel%20Coron%20Office!5e0!3m2!1sen!2sph!4v1741001779524!5m2!1sen!2sph"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        <div className="text-container">
          <h2>Our Location</h2>
          <a href="https://maps.app.goo.gl/8DnNJUn3t4aCqFFa8">
            <p>Poblacion 3, Barangay 3, Coron, 5316 Palawan</p>
          </a>
          <a href="tel+639066603788">
            <p>📞 +639066603788</p>
          </a>
          <a href="mailto:twintravelcoron.reservation@gmail.com">
            <p>✉️ twintravelcoron.reservation@gmail.com</p>
          </a>
        </div>
      </div>
    </div>
  );
};

export default AboutUsMap;
